import { IS_LOCAL } from './config'

/**
 * Determines if debug is enabled based on the environment or URL params.
 */
export const isDebugEnabled = (
  /**
   * Allows disabling the check for the environment, effectively requiring
   * the debug directive to be set.
   *
   * If not provided, debugging is considered active if the app is running locally.
   */
  considerEnv: boolean = true
): boolean => {
  return (
    (considerEnv ? IS_LOCAL : false) ||
    new URLSearchParams(window.location.search).get('debug') === 'true'
  )
}

/**
 * Logs a debug message if debugging is enabled, otherwise does nothing.
 */
export const debug = (...args: Parameters<typeof console.debug>) => {
  if (isDebugEnabled()) {
    // eslint-disable-next-line no-console
    console.debug(...args)
  }
}
